/**
 * 현재 선택된 지점명 배지
 * 모든 페이지 헤더에서 사용
 */

import React from 'react';

export default function StoreBadge({ className = '' }) {
  const storeName = localStorage.getItem('store_name');
  if (!storeName) return null;

  return (
    <span className={`store-badge-inline ${className}`}>
      📍 {storeName}
    </span>
  );
}
